import styles from './Vr.module.css';
import React from 'react';

// Vertical separator line
const Vr = (props) => {
  return <div className={styles.vr} {...props} />;
};

export default Vr;
